export const REACH_PAGE_EVENTS = {
  CAMPAIGNS_PAGE: {
    VIEW_CAMPAIGNS_PAGE: 'Campaigns Page Viewed',
    CLICK_CREATE_CAMPAIGN: 'Create Campaign Selected',
    TEMPLATE_DOWNLOADED: 'Campaigns Recepients Template Downloaded',
    CLICK_UPGRADE_FROM_CREATION: 'Campaigns Window Upgrade Selected',
    CAMPAIGN_CREATED_SUCCESS: 'Create Campaign Succeeded',
    CAMPAIGN_CREATED_ERROR: 'Create campaign Failed',
    CLICK_UPGRADE_FROM_MAIN: 'Campaigns Upgrade Selected',
    CAMPAIGN_ROW_OPENED: 'Campaign Row Opened',
    CAMPAIGN_DETAILS_VIEWED: 'Campaigns Details Viewed',
    CAMPAIGN_TERMINATE_SELECTED: 'Campaign Termination Selected',
    CAMPAIGN_TERMINATE_SUCCEEDED: 'Campaign Termination Succeeded',
    CAMPAIGN_TERMINATE_FAILED: 'Campaign Termination Failed',
  },
  CAMPAIGNS_ANALYSIS_PAGE: {
    VIEW_CAMPAIGNS_ANALYSIS_PAGE: 'Campaigns Analysis Page Viewed',
    CAMPAIGN_ANALYSIS_FILTER_APPLIED: 'Campaigns Date Filter Applied  ',
  },
  BUNDLES_PAGE: {
    VIEW_BUNDLES_PAGE: 'Bundles Page Viewed',
    SUBSCRIBE_BUNDLE_SELECTED: 'Subscribe Bundle Selected',
    SUBSCRIBE_BUNDLE_SUCCEEDED: 'Subscription Confirmation Succeeded',
    SUBSCRIBE_BUNDLE_FAILED: 'Subscription Confirmation Failed',
  },
};

export const REACH_PAGE_EVENTS_PROPERTIES = {
  SHARED: {
    ERROR_MESSAGE: 'error_description',
  },
  CAMPAIGNS_PAGE: {
    CAMPAIGN_CREATED_SUCCESS: {
      SENDER_NAME: 'sender_name',
      CAMPAIGN_TITLE: 'campaign_title',
      UPLOAD_CAMPAIGN_RECEPIENT: 'upload_campaign_recepient',
      DESCRIPTION: 'description',
      SMS_CONTENT: 'sms_content',
      CAMPAIGN_START_DATE: 'campaign_start_date',
      CAMPAIGN_TIME: 'campaign_time',
    },
    CAMPAIGN_DETAILS_VIEWED: {
      CAMPAIGN_ID: 'campaign_id',
      CAMPAIGN_STATUS: 'campaign_status',
      CAMPAIGN_CHANNEL: 'campaign_channel',
      IS_APPROVED: 'is_approved',
      IS_SENT: 'is_sent',
      TOTAL_CUSTOMERS: 'total_customers',
      START_DATE: 'start_date',
      APPROVED_DATE: 'approved_date',
      SMS_COUNT: 'sms_count',
      FAIL_SMS: 'fail_sms',
      SUCCESS_SMS: 'success_sms',
    },
  },
  CAMPAIGNS_ANALYSIS_PAGE: {
    TOTAL_CUSTOMERS: 'total_customers',
    TOTAL_CAMPAIGNS: 'total_campaigns',
    FAIL_SMS: 'fail_sms',
    SUCCESS_SMS: 'success_sms',
    DATE_FILTERED: 'date_filtered',
  },
  BUNDLES_PAGE: {
    BUNDLE_PLAN: 'bundle_plan',
  },
};
